const Danger = {
  danger: {
    main: '#DE0A14',
    light: '#F4676E',
    dark: '#AD0E11',
    '10': '#470003',
    '20': '#860003',
    '30': '#AD0E11',
    '40': '#DE0A14',
    '50': '#F4676E',
    '60': '#FFA4AC',
    '70': '#FFC8CD',
    '80': '#FFD8DC',
    '90': '#FAE2E5',
    '95': '#FFEFF1',
    '100': '#FFF9F9',
  },
};

export default Danger;
